import { cn, taskStatus } from "@/lib/utils";
import { Handle, Position } from "@xyflow/react";
import { memo } from "react";
import { ChevronRight, Folder, CalendarDays, Clock, ChevronLeft } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui";
import moment from "moment";

const CustomNode = (props: any) => {
  const { data, isConnectable, parentId, targetPosition, sourcePosition } = props;
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger className="mx-1" asChild>
          <div className={cn("p-2 rounded-sm bg-white border-1 w-[150px]", taskStatus[data?.actualStatus?.toLowerCase()]?.className)}>
            <div className="text-[14px] font-normal">{data.label}</div>
      
            {parentId ? <Handle
              type="target"
              position={targetPosition || Position.Left}
              className="w-16 pointer-none bg-none border-0"
              style={{
                background: 'none',
                border: 'none',
              }}
              isConnectable={isConnectable}
            >
              {targetPosition == Position.Right ? <ChevronLeft className="h-5 w-5 -mt-[7px] -ml-[10px]" /> : <ChevronRight className="h-5 w-5 -mt-[7px] -ml-[10px]" />}
            </Handle>: <></>}
            {data?.children?.length ? <Handle
              type="source"
              position={sourcePosition || Position.Right}
              className="w-16"
              isConnectable={isConnectable}
            /> : <></>}
          </div>
        </TooltipTrigger>
        <TooltipContent 
          onPointerDown={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
          className={cn(taskStatus[data?.actualStatus?.toLowerCase()]?.className, "w-[300px] border-1 pointer-events-auto")} arrowClassName={cn(taskStatus[data?.actualStatus?.toLowerCase()]?.className, "border-b-1 border-r-1")}>
          <div className="flex flex-col gap-2">
            <div className="flex flex-row items-center justify-between gap-2">
              <span className="text-[14px] font-semibold max-w-[150px]">{data?.label}</span>
              <div className={cn(taskStatus[data?.actualStatus?.toLowerCase()]?.className, "text-[12px] font-normal rounded-full px-2 py-1 border-1")}>{taskStatus[data?.actualStatus?.toLowerCase()]?.label}</div>
            </div>
            <div className="flex flex-col gap-2 text-[12px] font-medium text-stone-800">
              <div className="flex flex-row items-center gap-1 "><Folder className="h-4" />{data?.categoryName}</div>
              <div className="flex flex-row items-center gap-1 ml-3"><Folder className="h-4" />{data?.subCategoryName}</div>
              <div className="flex flex-row items-center gap-1"><CalendarDays className="h-4" /> {data?.plannedStartDate ? moment(data?.plannedStartDate).format('MM-DD-YYYY') : ''} to {data?.plannedEndDate ? moment(data?.plannedEndDate).format('MM-DD-YYYY') : ''}</div>
              <div className="flex flex-row items-center gap-1"><Clock className="h-4" /> Duration: {(moment(data?.plannedEndDate).diff(data?.plannedStartDate, "days") + 1) || "0"} Days</div>
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
 
export default memo(CustomNode);
